import ApiClient from '@afosto/api/ApiClient';

class Integrations {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Delete integration
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Update an integrations&#39; configuration
   * @returns {Promise}
   */
  disable(id, options = {}) {
    return this.apiClient.request({
      url: `/int/apps/integrations/${id}`,
      method: 'delete',
      ...options,
    });
  }

  /**
   * View integration
   *
   * @param {string} id
   * @param {Object} options - The additional request options
   * @description Get information for an integration
   * @returns {Promise}
   */
  getIntegration(id, options = {}) {
    return this.apiClient.request({
      url: `/int/apps/integrations/${id}`,
      method: 'get',
      ...options,
    });
  }

  /**
   * List integrations
   *
   * @param {Object} query - The optional path parameters
   * @param {string} [query.appCode]
   * @param {string} [query.isDeleted]
   * @param {Object} options - The additional request options
   * @description Returns list of active integrations
   * @returns {Promise}
   */
  listIntegrations(query = {}, options = {}) {
    const params = {
      app_code: query.appCode,
      is_deleted: query.isDeleted,
    };

    return this.apiClient.request({
      url: `/int/apps/integrations`,
      method: 'get',
      params,
      ...options,
    });
  }

  /**
   * Update integration
   *
   * @param {string} id
   * @param {Object} body
   * @param {Object} options - The additional request options
   * @description Update an integrations&#39; configuration
   * @returns {Promise}
   */
  updateIntegration(id, body, options = {}) {
    return this.apiClient.request({
      url: `/int/apps/integrations/${id}`,
      method: 'put',
      data: body,
      ...options,
    });
  }
}

export const integrations = new Integrations();

export default Integrations;
